import Vue from "vue";
import App from "./App.vue";
import router from "./router";

Vue.config.productionTip = false;

import sassStyles from "./assets/scss/common.module.scss";

import "./assets/css/bootstrap.min.css";
import "./assets/simple-line-icons/css/simple-line-icons.css";
import "./assets/css/fancybox/jquery.fancybox.css";
import "./assets/css/flexslider.css";
import "./assets/js/OwlCarousel2/assets/owl.carousel.min.css";
import "swiper/dist/css/swiper.min.css";
import "./assets/css/style.css";

import "./assets/js/jquery";
import "./assets/js/jquery.easing.1.3";
import "./assets/js/bootstrap.min";
import "./assets/js/jquery.flexslider";
import "./assets/js/custom";
import "./assets/js/OwlCarousel2/owl.carousel";


import lang from "./helper/lang";

Vue.prototype.$style = sassStyles;
Vue.prototype.$t = lang.t;


router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  next();
});

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");